const config = {
  apiKey: "AIzaSyCbJDmwAHwsmJzzAPwaZEoQGDVCW6rtooc",
  authDomain: "cloudpass.firebaseapp.com",
  databaseURL: "https://cloud-23519.firebaseio.com",
  projectId: "cloud-23519",
  storageBucket: "cloud-23519.appspot.com",
  messagingSenderId: "282563957007",
  appId: "1:282563957007:web:569f0512acd7c263"
};
export default config;